import { EMPTY_FIELD } from 'constants/emptyField';

import React, { useState } from 'react';

import ArrowDownward from '@mui/icons-material/ArrowDownward';
import ArrowUpward from '@mui/icons-material/ArrowUpward';
import { RecordContextProvider, useRecordContext } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { IconButton } from 'shared/mui/IconButtons';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import { Typography } from 'shared/mui/Typography';
import { TextField } from 'shared/react-admin/Fields';
import { Commission } from 'types/embedded/commission';

import { CommissionsTabsLadderStep } from './CommissionsTabsLadderStep';

export const CommissionsTabsLadder: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const record = useRecordContext<Commission>();

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <CardTable tableBodyProps={{ sx: { '& td': { width: '160px' } } }}>
        <TableRowWrapper label="Тип лесенки">
          <TextField
            emptyText={EMPTY_FIELD}
            source="ladder.ladderType.description"
            sx={{ textWrap: 'nowrap' }}
          />
        </TableRowWrapper>
        <TableRowWrapper label="Период оборота">
          <TextField
            emptyText={EMPTY_FIELD}
            source="ladder.periodType.description"
            sx={{ textWrap: 'nowrap' }}
          />
        </TableRowWrapper>
        <TableRowWrapper label="Способ расчёта">
          <TextField
            emptyText={EMPTY_FIELD}
            source="calculationMethod.description"
            sx={{ textWrap: 'nowrap' }}
          />
        </TableRowWrapper>
      </CardTable>
      <Box display="flex" justifyContent="space-between">
        <Typography fontSize="20px" fontWeight={500} variant="body1">
          Ступени
        </Typography>
        <IconButton onClick={() => setIsExpanded((prev) => !prev)}>
          {isExpanded ? <ArrowUpward color="primary" /> : <ArrowDownward color="primary" />}
        </IconButton>
      </Box>
      {isExpanded && (
        <Box display="grid" gap={3} gridTemplateColumns="repeat(3, 1fr)">
          {record?.ladder?.steps.map((step) => {
            return (
              <RecordContextProvider key={step.stepNumber} value={step}>
                <CommissionsTabsLadderStep />
              </RecordContextProvider>
            );
          })}
        </Box>
      )}
    </Box>
  );
};
